import { useState, useEffect } from "react";
import { api } from "../../services/apiService";
import { useAuth } from "../../contexts/AuthContext";

export default function useNotifications() {
  const { isAuthenticated } = useAuth();
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchUnread = async () => {
      try {
        const response = await api.notifications.getAll(1, 50, { naoLidas: true });
        setNotifications(response.data || []);
      } catch {
        setNotifications([]);
      }
    };

    fetchUnread();

    const handleUpdate = (event) => {
      if (event.detail) {
        setNotifications(prev => [...prev, event.detail]);
      } else {
        fetchUnread();
      }
    };
    window.addEventListener("notificationUpdated", handleUpdate);

    return () => {
      window.removeEventListener("notificationUpdated", handleUpdate);
    };
  }, [isAuthenticated]);

  return notifications;
}
